import api from "src/services/api";

export interface MotivoVisita {
  id: number;
  nombre: string;
  activo: number | boolean;
}

export interface PreguntaVisita {
  id: number;
  pregunta: string;
  activo: number | boolean;
  orden?: number;
  tipo_respuesta?: string;
}

export interface OpcionVisita {
  tipo_respuesta: string;
  codigo: string;
  etiqueta: string;
  orden?: number;
}

export interface ContextoVisita {
  ps_id: number;
  ps_codigo?: string;
  ps_nombre?: string;
  fiscal?: { id?: number; nombre?: string };
  jefe_operaciones?: string;
}

export interface SupervisorVisita {
  legajo: number;
  nombre: string;
  apellido?: string;
  nombre_completo?: string;
  cargo?: string;
}

export interface EvaluacionVisitasItem {
  id: number;
  ps_id: number;
  ps_codigo?: string;
  ps_nombre?: string;
  fecha_visita: string;
  fiscal_nombre?: string;
  jefe_operaciones?: string;
  motivo_id?: number;
  motivo_nombre?: string;
  respuesta_p12?: string;
  creado_en?: string;
}

export interface CrearEvaluacionVisitasPayload {
  ps_id: number;
  fecha_visita: string;
  motivo_id: number;
  respuestas: Array<{ pregunta_id: number; respuesta_codigo: string }>;
  comentarios?: string;
  plan_accion?: string;
  fecha_plan_accion?: string;
}

export async function listarMotivosVisitas(): Promise<MotivoVisita[]> {
  const { data } = await api.get("evaluacion-visitas/motivos");
  return data?.datos || [];
}

export async function listarPreguntasVisitas(): Promise<PreguntaVisita[]> {
  const { data } = await api.get("evaluacion-visitas/preguntas");
  return data?.datos || [];
}

export async function listarOpcionesVisitas(tipo?: string): Promise<OpcionVisita[]> {
  const qs = tipo ? `?tipo=${encodeURIComponent(tipo)}` : "";
  const { data } = await api.get(`evaluacion-visitas/opciones${qs}`);
  return data?.datos || [];
}

export async function obtenerContextoVisitas(psId?: number, psCodigo?: string | number): Promise<ContextoVisita | null> {
  const q = new URLSearchParams();
  if (psId) q.append("ps_id", String(psId));
  if (psCodigo !== undefined && psCodigo !== null && String(psCodigo).trim()) {
    q.append("ps_codigo", String(psCodigo).trim());
  }
  const suffix = q.toString() ? `?${q.toString()}` : "";
  const { data } = await api.get(`evaluacion-visitas/contexto${suffix}`);
  return data?.datos || null;
}

export async function buscarSupervisoresVisitas(psId: number, q?: string): Promise<SupervisorVisita[]> {
  const qs = new URLSearchParams();
  qs.append("ps_id", String(psId));
  if (q && String(q).trim()) qs.append("q", String(q).trim());
  const { data } = await api.get(`evaluacion-visitas/supervisores?${qs.toString()}`);
  return data?.datos || [];
}

export async function crearEvaluacionVisitas(payload: CrearEvaluacionVisitasPayload): Promise<{ id?: number }> {
  const { data } = await api.post("evaluacion-visitas/", payload);
  return data?.datos || {};
}

export async function listarEvaluacionesVisitas(params?: {
  ps_id?: number;
  desde?: string;
  hasta?: string;
  limit?: number;
  offset?: number;
}): Promise<EvaluacionVisitasItem[]> {
  const q = new URLSearchParams();
  if (params?.ps_id) q.append("ps_id", String(params.ps_id));
  if (params?.desde) q.append("desde", params.desde);
  if (params?.hasta) q.append("hasta", params.hasta);
  if (params?.limit) q.append("limit", String(params.limit));
  if (params?.offset) q.append("offset", String(params.offset));
  const suffix = q.toString() ? `?${q.toString()}` : "";
  const { data } = await api.get(`evaluacion-visitas/listar${suffix}`);
  return data?.datos || [];
}
